import React, { useState, useEffect } from 'react';
import axios from 'axios';

const DataView = () => {
  const [file, setFile] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [msg, setMsg] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get('/api/employees');
      setEmployees(res.data);
    } catch (e) { console.error(e); }
  };

  const handleImport = async () => {
    if (!file) { alert("Chưa chọn file!"); return; }
    const formData = new FormData();
    formData.append('file', file);
    setUploading(true);
    setMsg('⏳ Đang xử lý...');

    try {
      const res = await axios.post('/api/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setMsg('✅ ' + res.data.message + ' ' + (res.data.detail || ''));
      setFile(null);
      document.getElementById('fileInput').value = "";
      fetchData();
    } catch (err) {
      setMsg('❌ Lỗi: ' + (err.response?.data?.message || 'Upload thất bại'));
    } finally { setUploading(false); }
  };

  const filteredData = employees.filter(e => 
    e.employee_code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ padding: 20, maxWidth: 900, margin: '0 auto', fontFamily: 'Arial' }}>
      <h2 style={{ borderBottom: '2px solid #333', paddingBottom: 10 }}>📂 QUẢN LÝ DỮ LIỆU</h2>

      {/* IMPORT BOX */}
      <div style={{ background: '#e9ecef', padding: 20, borderRadius: 8, marginBottom: 20 }}>
        <h4>📥 Import File Text (Mỗi dòng 1 mã)</h4>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <input id="fileInput" type="file" accept=".txt" onChange={e => setFile(e.target.files[0])} style={{background:'white', padding:5}} />
          <button onClick={handleImport} disabled={uploading} style={{padding:'8px 20px', background:'#28a745', color:'white', border:'none', borderRadius:4, cursor:'pointer'}}>
            {uploading ? 'Đang chạy...' : 'BẮT ĐẦU IMPORT'}
          </button>
        </div>
        {msg && <div style={{marginTop:10, fontWeight:'bold', color: msg.includes('✅')?'green':'red'}}>{msg}</div>}
      </div>

      {/* DATA TABLE */}
      <div style={{display:'flex', justifyContent:'space-between', marginBottom:10}}>
        <strong>Tổng: {filteredData.length} bản ghi</strong>
        <input placeholder="🔍 Tìm mã..." value={searchTerm} onChange={e=>setSearchTerm(e.target.value)} style={{padding:5}} />
      </div>

      <div style={{ maxHeight: '500px', overflowY: 'auto', border: '1px solid #ddd', background:'white' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ position: 'sticky', top: 0, background: '#333', color:'white' }}>
            <tr>
              <th style={{ padding: 10, textAlign: 'left' }}>Mã NV</th>
              <th style={{ padding: 10, textAlign: 'left' }}>Họ Tên</th>
              <th style={{ padding: 10, textAlign: 'center' }}>Check-in?</th>
              <th style={{ padding: 10, textAlign: 'center' }}>Avatar</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((emp, i) => (
              <tr key={emp.id} style={{ borderBottom: '1px solid #eee', background: i%2===0?'#fff':'#f9f9f9' }}>
                <td style={{ padding: 10, fontWeight:'bold', color:'#007bff' }}>{emp.employee_code}</td>
                <td style={{ padding: 10 }}>{emp.full_name}</td>
                <td style={{ padding: 10, textAlign:'center' }}>{emp.is_checked_in ? '✅' : 'Checking...'}</td>
                <td style={{ padding: 10, textAlign:'center' }}>{emp.avatar_url ? '📷' : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataView;
